"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldFetchShades = void 0;
const shouldFetchShades = ({
  productCode,
  products
}) => Boolean(productCode) && (products?.length ?? 0) === 0;
exports.shouldFetchShades = shouldFetchShades;
